

module.exports = __webpack_require__.stylable.create(
    "DropDownCategories1266808962",
    {"classes":{"root":"DropDownCategories1266808962__root","TPADropdownBase":"","dropdown":"Dropdown861427759__dropdown","title":"DropdownOption4119688436__title","arrowIcon":"DropdownBase11668593__arrowIcon"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    10,
    "DropDownCategories1266808962",
    null
);
